export const formatTable = function() {
  window.setTimeout(function() {
    $(".el-table .cell").replaceWith(function() {
      return $(this).text();
    });
  }, 6);
};
